var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"store-title",class:_vm.border ? 'border' : null},[_c('i',{class:_vm.iconFont,style:(_vm.margin)}),_vm._v(_vm._s(_vm.title)+"\n")])}
var staticRenderFns = []

export { render, staticRenderFns }